export const maxDepth = (parents) => parents.reduce((mx, a) => Math.max(mx, a.depth), 0);
